import { goFeatures } from "../data/content"

export function GoFeaturesSection() {
  return (
    <div className="mk-section mk-section-alt">
      <div className="mk-container mk-text-center">
        <span className="mk-chip">
          <span className="mk-chip-icon">
            <img src="/marketing/go/icons/message.svg" alt="" />
          </span>
          Features
        </span>

        <h2 className="mk-title">
          Features that <span className="mk-title-accent">Set us apart</span>
        </h2>

        <div className="mk-features-grid">
          {goFeatures.map((feature) => (
            <div key={feature.title} className="mk-feature-card">
              <div className="mk-feature-icon">
                <img src={feature.iconSrc} alt="" />
              </div>
              <div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
